<template>
  <div class="pos-refund-container fullscreen">
    <div class="pos-refund-wrapper unpaid_booking">
      <header>{{ $t("unpaid") }} {{ $t("booking") }}</header>
      <button @click="callClose()" class="btn-modal-close">&times;</button>
      <div class="row  mt_70">
        <div class="col-lg-6 col-xl-4 col-6 mx-auto text-center">
          <div class="input-unpaid-reservation">
            <!-- <input v-model="reservation_id" type="text" required="required" />
             <label>{{ $tc('reservation', 1) }} {{ $t('Id') }}</label> -->
            <b-form-input
              v-debounce:500="onSearch"
              v-model="searchValue"
              placeholder="Search Reservation ID, Email, Name, Mobile."
              class=""
              type="search"
              v-on:search="onSearch"
              name="searchReservations"
              id="searchReservations"
              ref="searchReservations"
              tabindex="0"
            ></b-form-input>
            <VkeyboardFloat
              :ID="'searchReservations'"
              :onClickFun="
                () => {
                  showVKeyboard = !showVKeyboard;
                }
              "
            />
            <Vkeyboard
              :inputName="'searchReservations'"
              :showOrHide="showVKeyboard"
              :initialValue="searchValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="onSearch"
              @changeKeyboardInput="searchValue = $event"
              @onClickClose="
                () => {
                  showVKeyboard = false;
                }
              "
            />
          </div>
        </div>
        <div class="col-12 mt-5" v-if="searchValue">
          <table
            class="list-view-table mx-auto tableWidth"
            v-if="getReservationList.length > 0"
          >
            <thead>
              <tr>
                <th class="w-cell"
                  >{{ $tc("reservation", 1) }} {{ $t("id") }}</th
                >
                <th>Movie</th>
                <th class="w-cell">Date/Time</th>
                <th class="w-cell">Screen/Seats</th>
                <th>Customer Details</th>
                <th class="w-cell"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(transaction, transactionIndex) in getReservationList"
                :key="transactionIndex"
              >
                <td class="font-weight-bold">
                  {{ transaction.reservation_id }}
                </td>
                <td>
                  {{ transaction.movie_title }}
                </td>
                <td class="font-weight-bold">
                  {{
                    moment(transaction.ss_actual_start_date).format(
                      "DD.MMM.YYYY"
                    )
                  }}<br />
                  ({{ transaction.ss_start_show_time }})
                </td>
                <td>
                  {{ transaction.screen_name }} <br />
                  ({{ transaction.sl_seat_name }})
                </td>
                <td class="font-weight-bold"
                  >{{
                    transaction.guest_id
                      ? transaction.guest_name
                      : transaction.customer_full_name
                      ? transaction.customer_full_name
                      : "-"
                  }}
                  <br />
                  {{
                    transaction.guest_id
                      ? transaction.guest_email
                      : transaction.cust_email
                      ? transaction.cust_email
                      : "-"
                  }}
                  <br />
                  {{
                    transaction.guest_id
                      ? transaction.guest_mobile
                      : transaction.cust_mobile
                      ? transaction.cust_mobile
                      : "-"
                  }}</td
                >
                <!-- <td class="p-0">
                <tr>
                  <td class="font-weight-bold p-0 pl-1">Name</td>
                  <td class="p-0 pl-1">{{ transaction.guest_id ? transaction.guest_name : transaction.customer_full_name ? transaction.customer_full_name : '-' }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold p-0 pl-1">Email</td>
                  <td class="p-0 pl-1">{{ transaction.guest_id ? transaction.guest_email : transaction.cust_email ? transaction.cust_email : '-' }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold p-0 pl-1">Mobile</td>
                  <td class="p-0 pl-1">{{ transaction.guest_id ? transaction.guest_mobile : transaction.cust_mobile ? transaction.cust_mobile : '-' }}</td>
                </tr>
              </td> -->
                <td class="text-center">
                  <b-button
                    variant="default"
                    class="btn-blue pay-btn"
                    :disabled="disableBtn"
                    :class="disableBtn ? 'disableBtn' : ''"
                    @click="onSelectReservation(transaction)"
                    >{{ "Pay" }}</b-button
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <table
            v-if="loading && getReservationList.length == 0"
            class="list-view-table text-left mx-auto w-50 border"
            border="1"
          >
            <tbody>
              <tr>
                <td class="text-center" colspan="3">
                  <b-spinner
                    variant="dark"
                    label="Spinning"
                    class="translate-spinner"
                  ></b-spinner>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            v-if="!loading && getReservationList.length == 0"
            class="list-view-table text-left mx-auto w-50 border"
            border="1"
          >
            <tbody>
              <tr>
                <td class="text-center" colspan="3">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            @change="onChangePagination($event)"
            :per-page="perPage"
            aria-controls="my-table"
            class="my-3"
            v-if="getReservationList.length > 0"
          ></b-pagination>
        </div>
        <!-- <div class="col-12">
        <div class="mx-auto text-center my-4">
          <button v-on:click="onSubmit()" :disabled='!selectedReservations' class="btn-blue-lg">{{ $t('submit') }}</button>
        </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
  import ExhibitorService from "@/services/ExhibitorService.js";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

  export default {
    props: {
      onClickHandler: { type: Function },
      onClickSeat: { type: Function },
      enableClass: { type: Boolean },
    },
    components: { NoRecords, Vkeyboard, VkeyboardFloat },
    data() {
      return {
        disableBtn: false,
        showVKeyboard: false,
        reservation_id: null,
        searchValue: "",
        getReservationList: [],
        cinema_id: null,
        showdate: null,
        loading: false,
        currentPage: 1,
        rows: 0,
        perPage: 5,
        selectedReservations: "",
      };
    },
    beforeMount() {
      this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    },
    mounted() {
      this.$refs.searchReservations.focus();
    },
    watch: {
      "$store.getters.isReservationDetailsAvailable": function(newVal, oldVal) {
        if (newVal) {
          this.onClickSeat();
          this.onClickHandler("UnpaidBooking");
        }
      },
    },
    methods: {
      moment,
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.onSearchReservations();
        } else {
          this.currentPage = event;
          this.onSearchReservations();
        }
      },
      onSelectReservation(reservation) {
        if (reservation) {
          this.disableBtn = true;
          this.selectedReservations = reservation;
          this.reservation_id = reservation.reservation_id;
          this.onSubmit();
        } else {
          this.$toasted.show("Something Went Wrong!, Please try later");
          console.log("Error:No reservation Obj");
        }
      },
      checkSelectedReservation(transaction) {
        if (
          transaction &&
          this.selectedReservations &&
          transaction.reservation_id == this.selectedReservations.reservation_id
        ) {
          return true;
        } else {
          return false;
        }
      },
      onSearch() {
        if (this.searchValue && this.searchValue.length > 2) {
          this.currentPage = 1;
          this.onSearchReservations();
        } else if (!this.searchValue) {
          this.getReservationList = [];
        }
      },
      // onSelectReservation(reservation, reservationIndex) {
      //   this.selectedReservations = reservation;
      // },
      onSearchReservations() {
        this.getReservationList = [];
        let payload = {
          cinema_id: this.cinema_id,
          show_date: this.showdate || null,
          searchValue: this.searchValue,
          limit: this.perPage,
          currentPage: this.currentPage,
        };
        this.loading = true;
        this.selectedReservations = "";
        ExhibitorService.GetReservationsBySearch(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.getReservationList = data.Records;
              if (data.totalRows) {
                this.rows = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            this.loading = false;
          });
      },
      callClose: function() {
        this.$store.dispatch("Remove_Reservation_details");
        this.onClickHandler("UnpaidBooking");
        this.reservation_id = null;
      },
      onSubmit: function() {
        if (this.reservation_id && String(this.reservation_id).length > 7) {
          this.$store.dispatch(
            "Submit_Reservation_Details",
            this.reservation_id
          );
          setTimeout(() => {
            this.disableBtn = false;
          }, 3500);
        } else {
          this.$toasted.show("Please Provide Valid Reservation Details");
        }
      },
    },
  };
</script>
<style>
  .selected_border {
    border: 2px solid #3876d2;
  }

  .unpaid_booking .list-view-table th:first-child,
  .unpaid_booking .list-view-table th:last-child,
  .unpaid_booking .list-view-table th {
    padding: 10px;
  }

  .unpaid_booking .list-view-table td:first-child,
  .unpaid_booking .list-view-table td:last-child,
  .unpaid_booking .list-view-table td {
    padding: 8px;
  }

  .unpaid_booking thead {
    background-color: #f5f5f5;
  }

  .unpaid_booking .list-view-table th,
  .unpaid_booking .list-view-table td {
    border-right: 1px solid #eaeaed;
  }

  .unpaid_booking .list-view-table th:first-child,
  .unpaid_booking .list-view-table td:first-child {
    border-left: 1px solid #eaeaed;
  }

  .unpaid_booking .list-view-table th,
  .unpaid_booking .list-view-table td {
    border-bottom: 1px solid #eaeaed;
  }

  .unpaid_booking .list-view-table td {
    word-break: break-all;
  }

  .input-unpaid-reservation input {
    height: 100%;
    width: 100%;
    border: none;
    display: block;
    padding: 0 15px;
    background-color: white;
    min-height: 40px;
    overflow: hidden;
    border-radius: 10px;
    -webkit-transition: 0.3s ease;
    transition: 0.3s ease;
    border: 1px solid #d3d3d3;
  }

  .w-cell {
    width: 13%;
  }

  .mt_70 {
    margin-top: 70px;
  }

  .tableWidth {
    width: 85%;
  }

  .pay-btn {
    padding: 21px;
    font-size: 20px;
  }

  input#searchReservations::placeholder {
    font-style: italic;
    font-size: 13px;
  }

  .pos-refund-container .fullscreen {
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 999;
    height: 100%;
    padding: 16px;
    position: fixed;
    background-color: #fff;
    overflow-y: auto;
  }

  .disableBtn {
    pointer-events: none;
    opacity: 0.5;
  }

  .disableBtn {
    pointer-events: none;
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/UnpaidBooking.vue